import { render, staticRenderFns } from "./NominationsModeration.vue?vue&type=template&id=c46dd2e6&lang=pug"
import script from "./NominationsModeration.vue?vue&type=script&lang=js"
export * from "./NominationsModeration.vue?vue&type=script&lang=js"
import style0 from "./NominationsModeration.vue?vue&type=style&index=0&id=c46dd2e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports